module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_vm._l((_vm.headers), function(h) {
    return _c('th', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (h.show == undefined || h.show),
        expression: "h.show == undefined || h.show"
      }],
      staticClass: "side-by-side",
      class: {
        'dw-th': (h.sort == undefined || h.sort)
      },
      on: {
        "click": function($event) {
          _vm.orderBy(h)
        }
      }
    }, [_vm._v("\n        " + _vm._s(h.name) + "\n        "), (_vm.oBKey == h.key && _vm.oBDirection == 'asc') ? _c('i', {
      staticClass: "fa fa-sort-up icon-abs",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.oBKey == h.key && _vm.oBDirection == 'desc') ? _c('i', {
      staticClass: "fa fa-sort-down icon-abs",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.editable) ? _c('th', [_vm._v("Ações")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f38691a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/table/DWTableHead.vue
// module id = 901
// module chunks = 1